module.exports = __webpack_public_path__ + "img/gf icon.7f134bf6.svg";